import { StylesConfig, GroupBase } from 'react-select';

interface OptionType {
  value: string;
  label: string;
}

export const addressSelectStyle = (isFocused: boolean): StylesConfig<OptionType, false, GroupBase<OptionType>> => ({
  option: (provided: any, state: { isSelected: any; isFocused: any; }) => ({
    ...provided,
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    padding: 10,
    backgroundColor: state.isSelected ? '#00989E' : state.isFocused ? '#FFFFFF' : '#FFFFFF',
    color: state.isSelected ? '#ffffff' : '#333333',
    marginBottom: '2px',
    zIndex: '10',
    '&:hover': {
      backgroundColor: 'rgb(0 136 141 / 20%)',
      color: '#00989E',
    },
  }),
  control: (provided: any) => ({
    ...provided,
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    border: `1px solid #ced4da`,
    borderRadius: '13px',
    // padding: '6px',
    height: '55px',
    boxShadow: 'none',
    width: '100%', // Ensures the select spans the width of its container
    minHeight: 'unset', // Ensures the height is not constrained
    '&:hover': {
      borderColor: '#00989E'
    },
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: isFocused ? '18px 0px 0px 14px' : '8px', // Adjust padding based on focus state
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    display: 'none',
  }),
  menu: (provided: any, state: { selectProps: { menuPlacement: string; }; }) => ({
    ...provided,
    width: '100%',
    top: 'auto',
    bottom: 'auto',
    marginTop: '2px',
    marginBottom: '2px',
    zIndex: 9999,
    position: 'absolute',
    left: 0,
    right: 0,
    borderRadius: '13px',
    boxShadow: '0 1px 6px rgba(0, 0, 0, 0.1)',
    backgroundColor: 'white',
    overflow: 'hidden',
    '@media (max-width: 575.98px)': {
      position: 'fixed',
      left: '50%',
      bottom: '50px',
      transform: 'translate(-50%, 0%)',
      height: 'auto',
      width: 'calc(100% - 50px)',
    },
  }),
});
